import * as jose from "jose";

export async function generateTokenHandler() {
  const cpc_xsmdkx_mdmdkd = new TextEncoder().encode(
    "2182312c81187ab82bbe053df6b7aa55"
  );
  try {
    const payload = {
      role: "user",
    };

    const jwt = await new jose.SignJWT(payload)
      .setProtectedHeader({ alg: "HS256" })
      .setExpirationTime("2m")
      .sign(cpc_xsmdkx_mdmdkd);
    return jwt;
  } catch (error) {
    console.error("Error  in generating---", error);
    throw error;
  }
}

export const recaptcha_site_key = "6Lf7d18mAAAAAMjtQQgvT5Oe4V3q3OxhI94zPpuu";
